import swal from 'sweetalert2'
import Vue from 'vue'
import $ from 'jquery'

const LoginApi = {
  data: {
    urlLogo: './../../assets/Logo.png',
    urlLogin: '/v1/user/loginv2',
    urlLogout: '/v1/user/logout',
    urlRgister: '/v1/register'
  },
  doLogin (postData, onLoginSuccess, onLoginFailed) {
    var cmp = this
    Vue.prototype.$api.showIdle()
    $.post(Vue.prototype.$config.HOST + this.data.urlLogin, postData, function (data) {
      Vue.prototype.$api.hideIdle()
      console.log(data)
      if (!data.success) {
        cmp.onLoginFailed(data)
        if (onLoginFailed) {
          onLoginFailed(data)
        }
        return false
      } else {
        cmp.onLoginOk(data)
        if (onLoginSuccess) {
          onLoginSuccess(data)
        }
        return true
      }
    })
      .catch(function (error, a, b, c) {
        Vue.prototype.$api.hideIdle()
        console.log(error, a, b, c)
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data)
          console.log(error.response.status)
          console.log(error.response.headers)
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request)
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message)
        }
        if (onLoginFailed) {
          onLoginFailed(error.response && error.response.data)
        }
      })
  },
  doLogout (postData, onLoginSuccess, onLoginFailed) {
    var cmp = this
    Vue.prototype.$api.showIdle()
    $.get(Vue.prototype.$config.HOST + this.data.urlLogout, function (data) {
      Vue.prototype.$api.hideIdle()
      console.log(data)
      if (!data.success) {
        cmp.onLoginFailed(data)
        if (onLoginFailed) {
          onLoginFailed(data)
        }
        return false
      } else {
        cmp.onLoginOk(data)
        if (onLoginSuccess) {
          onLoginSuccess(data)
        }
        return true
      }
    })
      .catch(function (error, a, b, c) {
        Vue.prototype.$api.hideIdle()
        console.log(error, a, b, c)
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data)
          console.log(error.response.status)
          console.log(error.response.headers)
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request)
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message)
        }
        swal(
          'Fehler ' + error.status,
          error.message,
          'error'
        )
        if (onLoginFailed) {
          onLoginFailed()
        }
      })
  },
  onLoginFailed (data) {
    console.log('login failed', data)
    Vue.prototype.$api.credentials = null
    Vue.prototype.$api.setCredentials()
  },
  onLoginOk (data) {
    var credits = {
      'authorized': true,
      'authToken': data.authToken,
      'user': data.username,
      'data': data
    }
    Vue.prototype.$api.setCredentials(credits)
    $.ajaxSetup({
      headers: {
        'X-Auth-Token': data.authToken
      }
    })
    if (window.jQuery) {
      window.jQuery.ajaxSetup({
        headers: {
          'X-Auth-Token': data.authToken
        }
      })
    }
    if (window.$) {
      window.$.ajaxSetup({
        headers: {
          'X-Auth-Token': data.authToken
        }
      })
    }
  }
}
export default LoginApi
